import styled from "styled-components/native";

export const MainContainer = styled.View<{ theme: any }>`
  background-color: ${(props) => {
    return props.theme.palette.background;
  }};
  padding: 10px;
  display: flex;
`;
export const DefaultTheme = styled.TouchableOpacity`
  background-color: #787986;
  padding: 10px;
  margin: 10px;
`;

export const ThemedText = styled.Text<{ theme: any }>`
  font-size: ${props => props.theme.size};
  line-height: ${props => props.theme.lineHeight};
  font-family: ${props => props.theme.fontFamily};
`;
